module.exports = require('./helpers/bundle-url').getBundleURL('bRDu3') + "spritesheet.82782337.json";